export default __webpack_public_path__ + "9712dae9bc23097ea034f69486ec42dc.png";